import { Signal } from '@angular/core';
import { Store, Action, MemoizedSelector } from '@ngrx/store';
import { Observable } from 'rxjs';
import { ApplicationState } from '../reducers';

export class BaseActionService<TState extends ApplicationState> {
  constructor(protected store: Store<TState>) { }

  protected load<TAction extends Action>(action: TAction) {
    this.store.dispatch(action as Action);
  }

  protected get<TSelector extends MemoizedSelector<TState, TRes>, TRes>(
    action: TSelector,
  ): Observable<TRes> {
    return this.store.select<TRes>(action);
  }

  protected selectSignal<TRes>(selector: MemoizedSelector<TState, TRes>): Signal<TRes> {
    return this.store.selectSignal(selector);
  }
}
